var _defs, _rect, _g, _g2, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProbabilisticNumerics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad4",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#a855f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fb7185"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 480,
    rx: 24,
    fill: "url(#grad4)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "rgba(15,23,42,0.75)",
    fontFamily: "'Poppins', 'Segoe UI', sans-serif",
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("text", {
    x: 160,
    y: 180,
    fontSize: 38,
    fontWeight: 700
  }, "Probabilistic"), /*#__PURE__*/React.createElement("text", {
    x: 160,
    y: 228,
    fontSize: 38,
    fontWeight: 700
  }, "Numerics"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "rgba(15,23,42,0.58)",
    fontFamily: "'Fira Code', monospace",
    fontSize: 24,
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("text", {
    x: 160,
    y: 300
  }, "p(x|y) \u221D p(y|x)p(x)"))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 340,
    width: 240,
    height: 12,
    rx: 6,
    fill: "rgba(255,255,255,0.35)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 365,
    width: 160,
    height: 12,
    rx: 6,
    fill: "rgba(255,255,255,0.3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProbabilisticNumerics);
export default __webpack_public_path__ + "static/media/probabilistic-numerics.794c90912dab1ac3476264469a17c950.svg";
export { ForwardRef as ReactComponent };